// Софтфон для чата: перезвонить по голосовому автоответчика прямо из браузера.
// Регистрация ленивая — UA поднимается при первом звонке, а не у всех сотрудников постоянно.
// Учётка (chat1) и ICE приходят из админки по служебному ключу.
import JsSIP from 'jssip';

const ADMIN_API = 'https://zhylytaban.kz/admin/api';
const SYSTEM_KEY = 'shelter_chat_sync_2026';

let ua = null;
let cfg = null;
let session = null;
let audioEl = null;
const listeners = new Set();

export const state = {
  status: 'idle',        // idle | connecting | calling | ringing | talking | ended | error
  number: '',
  error: '',
  muted: false,
  seconds: 0,
};

let timer = null;

function emit() {
  listeners.forEach(fn => { try { fn({ ...state }); } catch (e) {} });
}

export function subscribe(fn) {
  listeners.add(fn);
  fn({ ...state });
  return () => listeners.delete(fn);
}

function setState(patch) {
  Object.assign(state, patch);
  emit();
}

function startTimer() {
  stopTimer();
  state.seconds = 0;
  timer = setInterval(() => { state.seconds += 1; emit(); }, 1000);
}

function stopTimer() {
  if (timer) { clearInterval(timer); timer = null; }
}

async function loadConfig() {
  if (cfg) return cfg;
  const res = await fetch(`${ADMIN_API}/telephony/chat/sip-config?key=${SYSTEM_KEY}`);
  if (!res.ok) throw new Error('нет доступа к настройкам телефонии');
  cfg = await res.json();
  return cfg;
}

function ensureAudio() {
  if (!audioEl) {
    audioEl = document.createElement('audio');
    audioEl.autoplay = true;
    audioEl.style.display = 'none';
    document.body.appendChild(audioEl);
  }
  return audioEl;
}

async function ensureUA() {
  const c = await loadConfig();
  if (ua && ua.isRegistered()) return ua;
  if (ua) { try { ua.stop(); } catch (e) {} ua = null; }

  const socket = new JsSIP.WebSocketInterface(c.ws_uri);
  ua = new JsSIP.UA({
    sockets: [socket],
    uri: c.sip_uri,
    password: c.password,
    display_name: 'Чат',
    register: true,
    session_timers: false,
  });

  ua.on('newRTCSession', ({ session: s, originator }) => {
    if (originator !== 'local') { try { s.terminate(); } catch (e) {} return; }  // входящие идут оператору в админку
    session = s;
    bind(s);
  });

  ua.start();

  await new Promise((resolve, reject) => {
    const t = setTimeout(() => reject(new Error('телефония не отвечает')), 12000);
    ua.once('registered', () => { clearTimeout(t); resolve(); });
    ua.once('registrationFailed', () => { clearTimeout(t); reject(new Error('не удалось подключиться к телефонии')); });
  });
  return ua;
}

function bind(s) {
  s.on('progress', () => setState({ status: 'ringing' }));
  s.on('confirmed', () => { startTimer(); setState({ status: 'talking' }); });
  s.on('ended', () => cleanup());
  s.on('failed', (e) => {
    const cause = (e && e.cause) || '';
    cleanup(cause === 'Busy' ? 'занято' : cause === 'Rejected' ? 'сброшен' : cause === 'Unavailable' ? 'недоступен' : '');
  });
  s.on('peerconnection', ({ peerconnection: pc }) => {
    pc.addEventListener('track', (ev) => {
      if (ev.track.kind === 'audio') ensureAudio().srcObject = ev.streams[0];
    });
  });
}

function cleanup(err) {
  stopTimer();
  session = null;
  if (audioEl) audioEl.srcObject = null;
  setState({ status: err ? 'error' : 'ended', error: err || '', muted: false });
  setTimeout(() => { if (!session) setState({ status: 'idle', error: '', seconds: 0 }); }, err ? 4000 : 2000);
}

export async function callNumber(number) {
  if (session) return;
  setState({ status: 'connecting', number, error: '', seconds: 0 });
  try {
    const c = await ensureUA();
    const opts = {
      mediaConstraints: { audio: { echoCancellation: true, noiseSuppression: true, autoGainControl: true }, video: false },
      pcConfig: { iceServers: c.ice_servers || [] },
      extraHeaders: ['X-SIM-Port: ' + (c.shelter_port != null ? c.shelter_port : 2)],
    };
    setState({ status: 'calling' });
    ua.call(`sip:${number}@${c.domain}`, opts);
  } catch (e) {
    cleanup(e.message || 'не удалось позвонить');
  }
}

export function hangup() {
  if (session) { try { session.terminate(); } catch (e) {} }
  else cleanup();
}

export function toggleMute() {
  if (!session) return;
  state.muted ? session.unmute({ audio: true }) : session.mute({ audio: true });
  setState({ muted: !state.muted });
}

export function fmtTime(s) {
  s = s || 0;
  return Math.floor(s / 60) + ':' + String(s % 60).padStart(2, '0');
}

// Отладочная точка: позволяет проверить связку из консоли браузера, не дёргая живых людей
// (например window.__vmPhone.callNumber('602') — тестовый тон Asterisk).
if (typeof window !== 'undefined') {
  window.__vmPhone = { callNumber, hangup, toggleMute, subscribe, state };
}
